<template>
    <div>
        <search @find="searchHander"></search>
        <div class="page-wrapper">
            <table-list 
                title="IC门禁卡列表"
                :columns="columns"
                :data="data"
                :total="total"
                :current="current"
                :loading="loading" 
                @change-page="changePage">
                <Button type="primary" class="btn" @click="ICHander" v-p="{api:'elevIcCard/saveIcCard'}">添加IC门禁卡</Button>
            </table-list>
        </div>
        <ic-modal 
            v-model="showModal" 
            @refresh="initList"></ic-modal>
        <ic-modal  
            v-model="editModal" 
            title="修改IC卡门禁"
            type="edit" 
            :buildingName="buildingName" 
            :cardUid="cardUid" 
            :deviceName="deviceName" 
            :endTime="endTime" 
            :projectName="projectName" 
            :buildingFid="buildingFid" 
            :deviceIdList="deviceIdList"
            @refresh="initList"></ic-modal>
    </div>
</template>
 
<script type="text/ecmascript-6">
import Search from './components/Search';
import TableList from 'components/TableList';
import IcModal from './components/Icmodal';
import { getIcList,delIc } from 'api/ladder.js';
export default {
    name:'ic',
    components: {
        Search,
        TableList,
        IcModal
    },
    data () {
        return {
            data:[],
            total:0,
            current : 1,
            loading:false,
            showModal:false,
            editModal:false,
            buildingName:'',
            cardUid:'',
            deviceName:null,
            endTime:'',
            projectName:'',
            buildingFid:'',
            deviceIdList:[],
            columns:[
              {
                type: 'index',
                width: 60,
                align: 'center'
              },
              {
                title: '项目名称',
                align: 'center',
                key: 'projectName',
                width: 200,
              },
              {
                title: '楼栋名称',
                align: 'center',
                key: 'buildingName',
                width: 200,
              },
              {
                title: '卡UID',
                align: 'center',
                key: 'cardUid',
                width: 200,
              },
              {
                title: '卡权限',
                align: 'center',
                key: 'deviceName',
                width: 300,
              },
              {
                title: '有效期截止时间',
                align: 'center',
                key: 'endTime',
                width: 200
              },
              {
                title: '操作',
                key: 'action',
                width: 150,
                align: 'center',
                fixed: 'right',
                render: (h, params) => {
                  return h('div', [h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    directives: [
                      {
                        name: 'p',
                        value: {
                          api: 'elevIcCard/updateIcCard'
                        }
                      }
                    ],
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.buildingName = params.row.buildingName;
                        this.cardUid = params.row.cardUid;
                        this.deviceName = params.row.deviceName;
                        this.endTime = params.row.endTime;
                        this.projectName = params.row.projectName;
                        this.buildingFid = params.row.buildingFid;
                        this.deviceIdList = params.row.deviceIdList || [];
                        this.editModal = true;
                      }
                    }
                  }, '修改'), h('Button', {
                    props: {
                      type: 'ghost',
                      size: 'small',
                    },
                    directives: [
                      {
                        name: 'p',
                        value: {
                          api: 'elevIcCard/delIcCard'
                        }
                      }
                    ],
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '删除',
                          content: '删除设备后无法恢复，确认删除本设备么？',
                          onOk: () => {
                            console.log(params);
                            this.cancelHander(params.row.cardUid);
                          }
                        })
                      }
                    }
                  }, '删除')])
                }
              }
            ],
            params:{
                projectFid:'',  //项目fid
                buildingFid:'', // 楼栋fid
                deviceType:'',
                cardUid:'',
                limit:10,
                page:1
            }
        }
    },
    created () {
      this.initList();
    },
    methods: {
        ICHander() {
            this.showModal = true;
        },
        changePage(n) {
            this.params.page = n;
            this.current = n;
			this.initList();
        },
        searchHander(params) {
            this.current = 1;
            this.params = JSON.parse(JSON.stringify(params));
            this.initList();
        },
        initList() {
            getIcList(this.params).then(res => {
                console.log(res);
                this.data = res.data.rows;
                this.total = res.data.total;
            })
        },
        cancelHander(cardUid) {
            delIc({cardUid}).then(res => {
                console.log(res);
                this.$Message.success('删除成功');
                this.initList();
            })
        }

    }
}
</script>
 
<style lang="css" scoped>
.btn{
    margin-bottom: 20px;
}
</style>
